import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Stvrt from '../views/Stvrt.vue'
import NovyDvor from '../views/NovyDvor.vue'
import PrveDomy from '../views/PrveDomy.vue'
import Promenada from '../views/Promenada.vue'
import NaHradzi from '../views/NaHradzi.vue'
import Nadvorie from '../views/Nadvorie.vue'
import BoryNoveBloky from '../views/BoryNoveBloky.vue'
import Novinky from '../views/News.vue'
import RetailZone from '../views/RetailZone.vue'
import RetailRozcestnik from '../views/RetailRozcestnik.vue'
import ObchodnePriestory from '../views/ObchodnePriestory.vue'
import NewsDetail from '../views/NewsDetail.vue'
import Gallery from '../views/Gallery.vue'
import Contact from '../views/Contact.vue'
import Flats from '../views/Flats.vue'
import Cookies from '../views/Cookies.vue'
import CookiesEmbed from '../views/CookiesEmbed.vue'
import Gdpr from '../views/Gdpr.vue'
import FlatDetail from '../views/FlatDetail.vue'
import FormularOdoslany from '../views/FormularOdoslany.vue'
import KartaBoryMall from '../views/pravidla-sutaze/KartaBoryMall.vue'
import OdporucteBoryGdpr from '../views/pravidla-sutaze/OdporucteBoryGdpr.vue'
import OdporucteBoryPodmienky from '../views/pravidla-sutaze/OdporucteBoryPodmienky.vue'
import UaFinancovanie from '../views/UaFinancovanie.vue'
import UaFinancovanieNadvorie from '../views/UaFinancovanieNadvorie.vue'
import StanoviskoPlyn from '../views/dokumenty/StanoviskoPlyn.vue'
import DefaultLayout from '../layouts/default.vue'
import RetailLayout from '../layouts/retail.vue'
import PageNotFound from '../views/404.vue'
import ZasadySpracovania from '../views/dokumenty/ZasadySpracovania.vue'
import Prieskum from '../views/dokumenty/Prieskum.vue'
import Nabytok from '../views/Nabytok.vue'
import DruzstevneByvanie from '../views/DruzstevneByvanie.vue'
import { setCookie } from '../utils/cookies'
import { uaRoutes } from '../plugins/w/translate'

import { i18n } from '../main'

Vue.use(VueRouter)

const availableLocales = ['en', 'ua'];

const mainChildren = [
  {
    path: '',
    name: 'Home',
    component: Home,
    meta: { title: 'Vitajte vo výbornej štvrti - Bory Bývanie' }
  },
  {
    path: 'nasa-stvrt',
    name: 'Naša štvrť',
    component: Stvrt,
    meta: { title: 'Naša štvrť - Bory Bývanie' }
  },
  {
    path: 'byvanie/bory1',
    name: 'Bory Bývanie Bory 1',
    component: PrveDomy,
    meta: { title: 'Bory Prvé Domy - Bory Bývanie' }
  },
  {
    path: 'byvanie/bory3',
    name: 'Bory Bývanie Bory 3',
    component: Promenada,
    meta: { title: 'Bory Promenáda - Bory Bývanie' }
  },
  {
    path: 'byvanie/na-hradzi',
    name: 'Bory Bývanie Na Hrádzi',
    component: NaHradzi,
    meta: { title: 'Bory Na Hrádzi - Bory Bývanie' }
  },
  {
    path: 'byvanie/nadvorie',
    name: 'Bory Bývanie Nádvorie',
    component: Nadvorie,
    meta: { title: 'Bory Nádvorie - Bory Bývanie' }
  },
  {
    path: 'byvanie/novy-dvor',
    name: 'Bory Bývanie Nový Dvor',
    component: NovyDvor,
    meta: { title: 'Nový Dvor - Bory Bývanie' }
  },
  {
    path: 'byvanie/nove-bloky',
    name: 'Bory Bývanie Nové Bloky',
    component: BoryNoveBloky,
    meta: { title: 'Nové Bloky - Bory Bývanie' }
  },
  {
    path: 'novinky',
    name: 'Novinky',
    component: Novinky,
    meta: { title: 'Novinky - Bory Bývanie' }
  },
  {
    path: 'novinky/:id',
    name: 'NewsDetail',
    component: NewsDetail,
    meta: { title: 'Novinky - Bory Bývanie' }
  },
  {
    path: 'galeria',
    name: 'Gallery',
    component: Gallery,
    meta: { title: 'Galéria - Bory Bývanie' }
  },
  {
    path: 'kontakt',
    name: 'Contact',
    component: Contact,
    meta: { title: 'Kontakt - Bory Bývanie' }
  },
  {
    path: 'byty',
    name: 'Flats',
    component: Flats,
    meta: { title: 'Byty - Bory Bývanie' }
  },
  {
    path: 'byty/:stage/:id',
    name: 'FlatDetail',
    component: FlatDetail,
    meta: { title: 'Vitajte vo výbornej štvrti - Bory Bývanie' }
  },
  {
    path: 'formular-odoslany',
    name: 'FormularOdoslany',
    component: FormularOdoslany,
    meta: { title: 'Formulár odoslaný' }
  },
  {
    path: 'pravidla-sutaze/vyhrajte-darcekovu-kartu-bory-mall',
    name: 'KartaBoryMall',
    component: KartaBoryMall,
    meta: { title: 'Vyhrajte darčekovú kartu Bory Mall' }
  },
  {
    path: 'zasady-pouzivania-suborov-cookies',
    name: 'Cookies',
    component: Cookies,
    meta: { title: 'Zásady používania súborov cookies' }
  },
  {
    path: 'cookies',
    name: 'CookiesEmbed',
    component: CookiesEmbed,
    meta: { title: 'Zásady používania súborov cookies' }
  },
  {
    path: 'pravidla-spracuvania-osobnych-udajov',
    name: 'Gdpr',
    component: Gdpr,
    meta: { title: 'Pravidlá spracúvania osobných údajov' }
  },
  {
    path: 'stanovisko-k-regulovanej-cene-plynu',
    name: 'StanoviskoPlyn',
    component: StanoviskoPlyn,
    meta: { title: 'Stanovisko spoločnosti Bory, a.s. k regulovanej cene plynu' }
  },
  {
    path: 'odporucte-bory-pravidla-spracuvania-osobnych-udajov',
    name: 'OdporucteBoryGdpr',
    component: OdporucteBoryGdpr,
    meta: { title: 'Pravidlá spracúvania osobných údajov' }
  },
  {
    path: 'podmienky-akcie-odporucte-projekt-bory-byvanie',
    name: 'OdporucteBoryPodmienky',
    component: OdporucteBoryPodmienky,
    meta: { title: 'Podmienky akcie Odporučte projekt Bory Bývanie' }
  },
  {
    path: 'ua-financovanie',
    name: 'UaFinancovanie',
    component: UaFinancovanie,
    meta: { title: 'фінансування' }
  },
  {
    path: 'ua-financovanie-nadvorie',
    name: 'UaFinancovanieNadvorie',
    component: UaFinancovanieNadvorie,
    meta: { title: 'фінансування' }
  },
  {
    path: 'zasady-spracovania-osobnych-udajov',
    name: 'ZasadySpracovania',
    component: ZasadySpracovania,
    meta: { title: 'ZÁSADY SPRACÚVANIA OSOBNÝCH ÚDAJOV' }
  },
  {
    path: 'prieskum-ohladom-druzstevneho-byvania',
    name: 'Prieskum',
    component: Prieskum,
    meta: { title: 'Prieskum ohľadom družstevného bývania' }
  },
  {
    path: 'nabytok',
    name: 'Nabytok',
    component: Nabytok,
    meta: { title: 'Nábytok - Akcia' }
  },
  {
    path: 'druzstevne-byvanie',
    name: 'DruzstevneByvanie',
    component: DruzstevneByvanie,
    meta: {title: 'Družstevné bývanie'}
  }
];

const routes: Array<RouteConfig> = [
  // Slovak default (no prefix)
  {
    path: '/',
    component: DefaultLayout,
    children: mainChildren
  },
  // English and Ukrainian with prefix
  {
    path: '/:locale(en|ua)',
    component: DefaultLayout,
    children: mainChildren
  },
  // Retail zone for en/ua
  {
    path: '/:locale(en|ua)/retail-zone',
    component: RetailLayout,
    children: [
      {
        path: '',
        name: 'RetailZone',
        component: RetailZone,
        meta: { title: 'Retail Zone - Bory Bývanie' }
      }
    ]
  },
  // Retail zone for SK (no prefix)
  {
    path: '/retail-zone',
    component: RetailLayout,
    children: [
      {
        path: '',
        name: 'RetailZone',
        component: RetailZone,
        meta: { title: 'Retail Zone - Bory Bývanie' }
      }
    ]
  },
  {
    path: '/retail',
    component: RetailLayout,
    children: [
      {
        path: '',
        name: 'RetailRozcestnik',
        component: RetailRozcestnik,
        meta: { title: 'Retail Zone - Bory Bývanie' }
      }
    ]
  },
  {
    path: '/obchodne-priestory',
    component: RetailLayout,
    children: [
      {
        path: '',
        name: 'ObchodnePriestory',
        component: ObchodnePriestory,
        meta: { title: 'Retail Zone - Bory Bývanie' }
      }
    ]
  },
  // 404 fallback
  {
    path: '*',
    component: DefaultLayout,
    children: [
      {
        path: '*',
        name: 'PageNotFound',
        component: PageNotFound,
        meta: { title: 'Page not found' }
      }
    ]
  }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to) {
      if (to.hash) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve({ selector: to.hash,
              behavior: 'smooth' })
          }, 1000)
        })
      } else {
        return {x: 0, y: 0}
      }
    }
})


router.beforeEach((to, from, next) => {
  const segments = to.path.split('/');
  const potentialLocale = segments[1];

  const isLangPrefixed = availableLocales.includes(potentialLocale);
  const hasUaTranslation = uaRoutes.includes(to.name || '');

  // ukrajinčina je len na stránkach s prekladom, inak presmeruj na sk verziu
  if (potentialLocale === 'ua' && !hasUaTranslation) {
    i18n.locale = 'sk';
    setCookie('locale', 'sk', 14);
    return next({
      path: '/' + to.fullPath.split('/').slice(2).join('/'),
      replace: true
    });
  }

  // ak ma prefix /en alebo /ua, nastav ho
  if (isLangPrefixed) {
    i18n.locale = potentialLocale;
    setCookie('locale', potentialLocale, 14);
    return next();
  }

  // ak som v angličtine alebo ukrajinčine a kliknem na odkaz bez prefixu
  // (z ukrajinčiny na stránku bez prekladu sa pokračuje v sk)
  const currentLocale = i18n.locale;
  if (currentLocale !== 'sk' && (currentLocale !== 'ua' || hasUaTranslation)) {
    return next({
      path: `/${currentLocale}${to.fullPath}`,
      replace: true
    });
  }

  // fallback na sk
  i18n.locale = 'sk';
  setCookie('locale', 'sk', 14);
  return next();
});


export default router
